import { useState } from 'react';
import { AccountSelectionPage } from './account-selection/AccountSelectionPage';
import { CorporateProSignupPage } from './corporate-pro-sign-up/CorporateProSignupPage';
import { RepSignUpPage } from './rep-sign-up/RepSignUpPage';
import { TransformProSignUpPage } from './transform-pro-sign-up/TransformProSignUpPage';
import { VolunteerSelectionPage } from './volunteer-selection/VolunteerSelectionPage';
import { useSearchParams } from 'wouter';

export const HomeSignUp = () => {
  const [searchParams] = useSearchParams();
  const orgInviteIdParam = searchParams.get('invite_id');
  const [representativeSelected, setRepresentativeSelected] = useState(false);
  const [volunteerSelected, setVolunteerSelected] = useState(false);
  const [corporateVolunteerSelected, setCorporateVolunteerSelected] = useState(false);
  const [individualVolunteerSelected, setIndividualVolunteerSelected] = useState(false);

  if (representativeSelected || orgInviteIdParam) {
    return <RepSignUpPage setRepresentativeSelected={setRepresentativeSelected} />;
  }

  if (corporateVolunteerSelected) {
    return <CorporateProSignupPage setCorporateVolunteerSelected={setCorporateVolunteerSelected} />;
  }
  if (individualVolunteerSelected) {
    return (
      <TransformProSignUpPage setIndividualVolunteerSelected={setIndividualVolunteerSelected} />
    );
  }

  if (volunteerSelected) {
    return (
      <VolunteerSelectionPage
        setCorporateVolunteerSelected={setCorporateVolunteerSelected}
        setIndividualVolunteerSelected={setIndividualVolunteerSelected}
        setVolunteerSelected={setVolunteerSelected}
      />
    );
  }

  return (
    <AccountSelectionPage
      setRepresentativeSelected={setRepresentativeSelected}
      setVolunteerSelected={setVolunteerSelected}
    />
  );
};
